var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c(_vm.template, {
    tag: "component"
  }, [_c('v-container', [_c('div', {
    staticClass: "contents-area"
  }, [_c('div', {
    staticClass: "contents-area__inner mx-auto",
    staticStyle: {
      "max-width": "800px"
    }
  }, [_c('div', {
    staticClass: "tit-wrap tit-wrap--unberline"
  }, [_c('h2', {
    staticClass: "tit"
  }, [_vm._v("상품권 구매하기")]), _c('div', {
    staticClass: "mt-4px mt-lg-8px font-size-14 font-size-md-16 grey--text text--garken-3"
  }, [_vm._v(" PG 결제를 통해 나누리 캐시 교환권을 구매하실 수 있습니다. ")])]), !_vm.order._id ? [_c('div', {
    staticClass: "mx-auto",
    staticStyle: {
      "max-width": "480px"
    }
  }, [_c('v-row', {
    staticClass: "ma-n1"
  }, [_c('v-col', {
    staticClass: "pa-1"
  }, [_c('v-btn', {
    attrs: {
      "x-large": "",
      "block": ""
    },
    on: {
      "click": _vm.exit
    }
  }, [_vm._v(" 홈으로 ")])], 1), _c('v-col', {
    staticClass: "pa-1"
  }, [_c('v-btn', {
    attrs: {
      "x-large": "",
      "block": "",
      "color": "primary"
    },
    on: {
      "click": _vm.more
    }
  }, [_vm._v(" 추가 구매하기 ")])], 1)], 1)], 1)] : _vm.gainable ? [_c('v-card', {
    staticClass: "my-20px my-lg-40px mx-auto",
    attrs: {
      "max-width": "480",
      "color": "transparent",
      "elevation": "0"
    }
  }, [_c('v-card-title', {
    staticClass: "justify-center"
  }, [_vm._v(" 나누리캐시 자동충전 ")]), _c('v-card-text', {
    staticClass: "pb-0 text-center"
  }, [_vm._v(" 충전 전 구매하신 상품권 내역을 다시 확인해주세요. ")])], 1), _c('nshop-order-view-pins', _vm._b({
    staticClass: "my-20px my-lg-40px mx-auto",
    staticStyle: {
      "max-width": "480px"
    },
    attrs: {
      "dense": ""
    }
  }, 'nshop-order-view-pins', {
    value: _vm.order
  }, false)), _c('purchase-gain-amount', _vm._b({
    staticClass: "my-20px my-lg-40px mx-auto",
    staticStyle: {
      "max-width": "480px"
    },
    attrs: {
      "dense": ""
    }
  }, 'purchase-gain-amount', {
    value: _vm.order
  }, false)), _c('div', {
    staticClass: "mx-auto",
    staticStyle: {
      "max-width": "480px"
    }
  }, [_c('v-row', {
    staticClass: "ma-n1"
  }, [_c('v-col', {
    staticClass: "pa-1"
  }, [_c('v-btn', {
    attrs: {
      "x-large": "",
      "block": ""
    },
    on: {
      "click": _vm.exit
    }
  }, [_vm._v(" 취소하기 ")])], 1), _c('v-col', {
    staticClass: "pa-1"
  }, [_c('v-btn', _vm._b({
    attrs: {
      "x-large": "",
      "block": "",
      "color": "primary"
    },
    on: {
      "click": _vm.gain
    }
  }, 'v-btn', {
    loading: _vm.loading
  }, false), [_vm._v(" 충전하기 ")])], 1)], 1)], 1)] : true ? [_c('v-card', {
    staticClass: "my-20px my-lg-40px",
    attrs: {
      "color": "transparent",
      "elevation": "0"
    }
  }, [_c('v-card-title', {
    staticClass: "justify-center"
  }, [_vm._v(" 자동충전이 불가능한 주문입니다 ")]), _vm.canceled ? _c('v-card-text', {
    staticClass: "text-center"
  }, [_vm._v(" 취소된 주문입니다. ")]) : _c('v-card-text', {
    staticClass: "text-center"
  }, [_vm._v(" 주문이 완료되지 않았거나"), _c('br'), _vm._v(" 이미 충전이 완료된 주문입니다. ")])], 1), _c('div', {
    staticClass: "mx-auto",
    staticStyle: {
      "max-width": "480px"
    }
  }, [_c('v-row', {
    staticClass: "ma-n1"
  }, [_c('v-col', {
    staticClass: "pa-1"
  }, [_c('v-btn', {
    attrs: {
      "x-large": "",
      "block": ""
    },
    on: {
      "click": _vm.exit
    }
  }, [_vm._v(" 홈으로 ")])], 1), _c('v-col', {
    staticClass: "pa-1"
  }, [_c('v-btn', {
    attrs: {
      "x-large": "",
      "block": "",
      "color": "primary"
    },
    on: {
      "click": _vm.more
    }
  }, [_vm._v(" 추가 구매하기 ")])], 1)], 1)], 1)] : _vm._e()], 2)])]), _c('common-loader', _vm._b({}, 'common-loader', {
    loading: _vm.loading
  }, false)), _c('common-message-dialog', {
    ref: "messageDialog"
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }